import React from "react";
import { useSelector } from "react-redux";
import { Button, Spinner } from "react-bootstrap";

function SpinnerButton({
  id,
  variant,
  onClick,
  disabled,
  name,
  buttonClassnames = "",
}) {
  const { activeSpinner } = useSelector((state) => state.sessionSlice);

  return (
    <>
      <Button
        onClick={onClick}
        disabled={disabled}
        variant={variant}
        className={buttonClassnames}
      >
        {activeSpinner && activeSpinner.id === id && (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        )}
        {(!activeSpinner || activeSpinner.id !== id) && <span>{name}</span>}
      </Button>
    </>
  );
}

export default SpinnerButton;
